{
    "smartTasks": {
        "generate": {
            "focusApp": {
                "title": "Concentrati sull'app",
                "description": "Assicurati di concentrarti sull'app in cui desideri che appaia il testo generato. Potrai generare il testo in modo fluido in quella posizione cliccando su Genera."
            }
        },
        "rewrite": {
            "focusApp": {
                "title": "Concentrati sull'app",
                "description": "Assicurati di concentrarti sull'app in cui desideri che appaia il testo riscritto. Potrai generare il testo in quella posizione senza problemi cliccando su \"Genera\"."
            }
        }
    },
    "customControls": {
        "tourLabel": "Controlli globali e dei dispositivi sempre disponibili",
        "rowDescription": "I controlli globali e del dispositivo sono sempre disponibili se il microfono è attivo, indipendentemente dall'app utilizzata. Puoi utilizzare questi controlli per interagire con il dispositivo senza dover creare nuovi controlli per le app. Contengono comandi utili come lo scambio di controlli o app, la generazione di testo, la messa in pausa del microfono e altro ancora."
    },
    "profile": {
        "switch": {
            "title": "Cambia i controlli dell'app",
            "description": "I controlli dell'app possono cambiare automaticamente in base all'app in uso, oppure puoi modificarli manualmente in qualsiasi momento qui."
        }
    },
    "dictation": {
        "tourLabel": "Dettatura",
        "learn": "Scopri come usare la modalità dettatura per convertire i tuoi discorsi in testo senza usare le mani.",
        "welcome": {
            "title": "Dettatura",
            "description": "La dettatura ti permette di parlare in modo naturale e di sentire le parole digitate mentre parli. È come avere un assistente personale che digita tutto quello che dici."
        },
        "microphone": {
            "title": "Accendi il microfono",
            "description": "Per prima cosa, accendi il microfono. Fai clic sull'interruttore del microfono nel pannello Cephable."
        },
        "activate": {
            "title": "Avvia la modalità di dettatura",
            "description": "La voce si avvia in modalità comando. Per avviare la dettatura, pronuncia \"Avvia dettatura\" o fai clic sul pulsante Dettatura. Attiviamo ora la modalità dettatura."
        },
        "focus": {
            "title": "Concentrati su un campo di testo o un documento",
            "description": "La dettatura funziona meglio quando ci si concentra su un campo di testo o un documento. Fare clic sul campo di testo o sul documento in cui si desidera dettare."
        },
        "speaking": {
            "title": "Inizia a parlare",
            "description": "Ora puoi iniziare a parlare. Tutto ciò che dici verrà digitato nel campo di testo o nel documento su cui ti sei concentrato. Prova a dire qualcosa come \"Ciao, questo è un test della modalità dettatura\"."
        },
        "pauseResume": {
            "title": "Mettere in pausa la dettatura",
            "description": "Hai bisogno di una pausa senza disattivare la dettatura? Basta dire \"Metti in pausa la dettatura\". Puoi riprendere la dettatura in qualsiasi momento premendo di nuovo \"Avvia dettatura\". Puoi personalizzare ulteriormente questa impostazione con i controlli globali e del dispositivo sempre attivi."
        },
        "stop": {
            "title": "Interruzione della dettatura",
            "description": "Devi tornare ai controlli dell'app? Basta dire \"Interrompi dettatura\". Questo interromperà la modalità dettatura e ti riporterà alla modalità comando. Puoi riprendere in qualsiasi momento premendo nuovamente \"Avvia dettatura\"."
        },
        "complete": {
            "description": "Ecco fatto! Ora puoi dettare, mettere in pausa, riprendere e passare dalla modalità dettatura a quella di comando. La dettatura è un potente strumento per la digitazione a mani libere. Usala per scrivere email, documenti o qualsiasi altra cosa tu debba digitare ad alta voce."
        }
    },
    "microphone": {
        "tourLabel": "Comandi vocali",
        "learn": "Scopri come usare la voce per controllare qualsiasi app e come usare la dettatura per scrivere ciò che dici.",
        "rowDescription": "Quando il microfono è disattivato, non ascolteremo affatto i tuoi comandi vocali, ma se lo attivi, potrai usare i comandi globali per attivare/disattivare pausa, avvio e altro ancora. Attiviamolo.",
        "tryOpen": {
            "title": "Prova a dire `Apri Spotify` o `Apri Word`"
        },
        "finishedCommands": {
            "title": "Ottimo! Hai imparato le basi dei comandi vocali.",
            "description": "Puoi sempre rivedere il tour dalla pagina di supporto. Il passo successivo è imparare a usare la dettatura. Puoi avviare il tour dalla pagina di supporto."
        }
    },
    "tour": {
        "startTour": "Inizia il tour",
        "finishTour": "Fine del tour",
        "statusDialog": "Per maggiori informazioni consultare il pannello.",
        "step": "Passo {{step}} di {{total}}",
        "skipTour": "Salta il tour"
    },
    "onboarding": {
        "overview": "Panoramica",
        "learn": "Scopri le funzionalità di Cephable e come utilizzarle.",
        "start": "Sembra che tu abbia appena iniziato. Ecco alcuni aspetti che ti aiuteranno lungo il percorso.",
        "dashboard": {
            "title": "Spazio di lavoro Cephable",
            "description": "Cephable Workspace è il tuo centro di controllo per gestire il dispositivo, le app e le impostazioni. Da qui puoi personalizzare la tua esperienza, visualizzare i comandi attivi e accedere a tutte le funzionalità di Cephable."
        },
        "step1": {
            "title": "Benvenuti a Cephable",
            "description": "Cephable è la tua intelligenza artificiale personale, progettata per azioni rapide, comandi vocali, generazione di contenuti e automazione intelligente su tutti i tuoi strumenti. Controlli pronti all'uso. Nessuna elaborazione cloud. Solo produttività che si muove con te."
        },
        "finish": {
            "continueToApp": "Continua alla dashboard di Cephable",
            "keepExploring": "Continua a esplorare"
        },
        "useCaseSlider": {
            "context": "Vorrei usare",
            "control": "controllare"
        }
    },
    "support": {
        "description": "Per maggiori informazioni su come utilizzare Cephable, tra cui ulteriori tour, guide dettagliate, tutorial e video, puoi visitare il nostro hub di supporto.",
        "title": "Supporto"
    },
    "editingVideos": {
        "tourLabel": "Concentrati sulla storia, non sui noiosi clic per il montaggio video",
        "learn": "Impara a usare i comandi vocali e la dettatura per modificare i video più velocemente ed eliminare lo sforzo cognitivo di dover ricordare quali pulsanti cliccare durante la modifica.",
        "tryOpen": {
            "title": "Prova a dire \"Apri CapCut\" o \"Apri iMovie\"."
        },
        "complete": {
            "description": "Ora sai come usare i comandi vocali e le azioni rapide per riprodurre, mettere in pausa, saltare le tracce e regolare il volume nelle tue app di editing video preferite. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un controllo video ancora più fluido."
        }
    },
    "congrats": "Congratulazioni!",
    "fpsGamePlay": {
        "tourLabel": "Gioca ai giochi FPS con i comandi vocali",
        "learn": "Scopri come usare i comandi vocali e le azioni rapide per giocare ai giochi FPS.",
        "tryOpen": {
            "title": "Prova a dire `Apri Valorant` o `Apri Battlefield`"
        },
        "complete": {
            "description": "Ora sai come usare i comandi vocali e le azioni rapide per muoverti, fermarti e controllare il tuo personaggio nei giochi FPS. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un gameplay ancora più fluido e veloce."
        }
    },
    "redo": "Ripeti l'onboarding",
    "title": "Incontra Cephable",
    "description": "Incontra Cephable, il tuo assistente AI personale e condividi il tuo interesse per i casi d'uso personalizzati.",
    "panel": {
        "description": "Questo è il pannello, ovvero il centro di controllo principale. È sempre visibile e ti permette di controllare le tue app usando la voce, e altro ancora. Iniziamo con il microfono."
    },
    "controlExpanded": {
        "tourLabel": "Controllare",
        "description": "I controlli dell'app sono insiemi configurabili di controlli che è possibile utilizzare in una determinata applicazione. Questa sezione mostra tutti i controlli disponibili che è possibile utilizzare tramite comandi vocali, tocchi, digitazione e altro ancora."
    },
    "submit": {
        "title": "Invia",
        "description": "Il contenuto verrà visualizzato nella posizione in cui si trova il cursore."
    },
    "tryOpen": {
        "description": "`Apri` è un comando globale che apre l'app specificata e le assegna il focus. Se è abilitata la commutazione automatica dei controlli, verranno visualizzati anche i controlli dell'app più adatti all'app in uso."
    },
    "modeSelector": {
        "title": "Seleziona la modalità",
        "description": "Se disponibile, puoi selezionare la modalità in cui opererò. Usa Controllo per l'app tramite cui desideri inviare i comandi, Crea per contenuti di testo generativi come riassunto, riscrittura, traduzione. Seleziona Automatizza per flussi desktop o tra app."
    },
    "contextSelector": {
        "title": "Seleziona lo sfondo",
        "description": "Se disponibile, puoi selezionare il contesto in cui opererò. Ad esempio, posso utilizzare gli appunti o il testo evidenziato, e puoi anche allegare file o cartelle con cui desideri che io lavori."
    },
    "panelInput": {
        "title": "Cosa vuoi che faccia?",
        "description": "Puoi impartire comandi, digitare o dettare ciò che desideri che io faccia."
    },
    "figma": {
        "tourLabel": "Comandi vocali per Figma e Canva",
        "learn": "Scopri come utilizzare i comandi vocali, il mouse vocale, la dettatura e la generazione di contenuti tramite intelligenza artificiale di Controls per migliorare il tuo flusso di lavoro di progettazione.",
        "complete": {
            "description": "Ora sai come controllare e creare progetti per ottimizzare il tuo flusso di lavoro. Prova a esplorare altri comandi per un controllo ancora più fluido dei tuoi progetti."
        },
        "tryOpen": {
            "title": "Prova a dire \"Apri Figma\" o \"Apri Canvas\"."
        }
    },
    "voiceMouse": {
        "title": "Voice Mouse",
        "description": "Per cliccare sui pulsanti in base al nome, puoi usare Voice Mouse. Puoi attivarlo dicendo \"tocca salva\" o \"vai alle impostazioni\"."
    },
    "documentSummary": {
        "tourLabel": "Bozza di sintesi del team basata su rapporti riservati.",
        "learn": "Automatizza la lettura dei report di reparto, identifica le persone giuste da informare e redigi un'e-mail, il tutto direttamente sul dispositivo, garantendo così la privacy dei tuoi dati riservati.",
        "congrats": {
            "description": "Ora sai come utilizzare i flussi di lavoro basati sull'intelligenza artificiale per leggere documenti riservati e redigere un'e-mail riassuntiva da inviare al tuo team, il tutto senza che i tuoi dati lascino il tuo dispositivo."
        }
    },
    "extensions": {
        "tourLabel": "Estensioni",
        "rowDescription": "Estendi le funzionalità di Cephable con ulteriori metodi di controllo del dispositivo, come i controlli della fotocamera per i movimenti del viso e della testa o il supporto per i gamepad. Attiva quelli che ti servono qui."
    },
    "developerBuildTests": {
        "tourLabel": "Automatizza build e test con flussi di lavoro basati sull'intelligenza artificiale.",
        "learn": "Cephable è in grado di eseguire attività da terminale composte da più fasi, come la compilazione del progetto e l'esecuzione dei relativi test, interamente sul dispositivo, in background, mentre tu continui a lavorare.",
        "complete": {
            "description": "Ora sai come eseguire flussi di lavoro AI sul dispositivo per attività di compilazione e test a più fasi, rispondere alle richieste di autorizzazione e continuare a iterare sui risultati. Prova ad automatizzare un'altra attività di sviluppo ripetitiva."
        }
    },
    "classroomStudyTools": {
        "tourLabel": "Trasforma gli appunti e gli articoli presi in classe in strumenti di studio e materiali didattici",
        "learn": "Cephable supporta insegnanti e studenti con la dettatura, strumenti di creazione integrati e funzionalità di automazione, direttamente nelle app che già utilizzano, garantendo la privacy e la sicurezza dei dati sul proprio dispositivo.",
        "complete": {
            "description": "Ora sai come dettare direttamente nei tuoi documenti, generare nuovi materiali di studio dai tuoi appunti e utilizzare Automate per creare compiti completi in background, tutto sul tuo dispositivo."
        }
    },
    "engineeringFlows": {
        "tourLabel": "Comandi vocali e automazioni basate sull'intelligenza artificiale per sviluppatori.",
        "learn": "Scopri come velocizzare il tuo flusso di lavoro di sviluppo con comandi vocali, la riscrittura automatica del codice tramite IA utilizzando il tuo codice come contesto e flussi di lavoro IA in background, il tutto in esecuzione direttamente sul dispositivo.",
        "tryOpen": {
            "title": "Prova a dire \"Apri Visual Studio Code\"."
        },
        "complete": {
            "description": "Ora sai come utilizzare i comandi di sviluppo a controllo vocale, la funzione AI Rewrite con il tuo codice come contesto e i flussi di lavoro AI in background per velocizzare il tuo flusso di lavoro di sviluppo."
        }
    },
    "meetingNotesToFiles": {
        "tourLabel": "Trasforma gli appunti delle riunioni in file utilizzabili",
        "learn": "Cephable può suddividere gli appunti delle riunioni in file più piccoli e gestibili, che puoi consultare al tuo ritmo, interamente sul tuo dispositivo.",
        "complete": {
            "description": "Ora sai come utilizzare i flussi di lavoro basati sull'IA per suddividere gli appunti delle riunioni in file più piccoli e gestibili, e riprendere la conversazione in qualsiasi momento dalla cronologia dell'IA."
        }
    },
    "notesToPresentation": {
        "tourLabel": "Riassumi appunti riservati e crea una presentazione, tutto direttamente sul dispositivo.",
        "learn": "Cephable è in grado di riassumere i tuoi report e appunti riservati, quindi utilizzare i flussi di lavoro basati sull'intelligenza artificiale per farlo su un'intera cartella di file e persino creare una presentazione dai risultati. Il tutto viene eseguito direttamente sul dispositivo.",
        "complete": {
            "description": "Ora sai come riassumere documenti riservati, riassumere in blocco un'intera cartella con i flussi di lavoro basati sull'intelligenza artificiale e trasformare i risultati in una presentazione, il tutto senza che i tuoi dati lascino il tuo dispositivo."
        }
    },
    "organizeDownloads": {
        "tourLabel": "Organizza i file, fai pulizia e ritrova ciò che hai perso: con i flussi di lavoro basati sull'intelligenza artificiale.",
        "learn": "Automate è in grado di gestire attività di gestione dei file in più fasi, come la copia, l'eliminazione e la ricerca di file, con un semplice comando.",
        "complete": {
            "description": "Ora sai come utilizzare i flussi di lavoro basati sull'intelligenza artificiale per organizzare i file, eliminarli in modo sicuro con controlli di autorizzazione e trovare i file di cui non ricordi la posizione."
        }
    },
    "outlookEmailProductivity": {
        "tourLabel": "Velocizza la posta elettronica in Outlook con la dettatura, le azioni rapide e l'intelligenza artificiale.",
        "learn": "Cephable Plus e Professional includono strumenti intelligenti di dettatura e creazione per generare e modificare contenuti: utilizzali direttamente in Outlook per rispondere e redigere email più velocemente.",
        "complete": {
            "description": "Ora sai come rispondere alle email tramite dettatura, utilizzare le tue azioni di digitazione rapida e usare le funzioni Riepiloga e Genera per redigere e perfezionare il contenuto delle email, tutto direttamente sul dispositivo."
        }
    },
    "customizingGameControls": {
        "tourLabel": "Gioca ai giochi di ruolo con i comandi vocali",
        "learn": "Impara a usare i comandi vocali e le azioni rapide per giocare ai giochi di ruolo.",
        "tryOpen": {
            "title": "Prova a dire \"Apri Minecraft\"."
        },
        "complete": {
            "description": "Ora sai come usare i comandi vocali e le azioni rapide per muovere, fermare e controllare il tuo personaggio nei giochi di ruolo. Prova a esplorare altri comandi o a personalizzare le tue azioni rapide per un'esperienza di gioco ancora più fluida e veloce."
        }
    },
    "voiceToTextSocialMedia": {
        "tourLabel": "Sintesi vocale per LinkedIn, Slack e Discord",
        "learn": "Utilizza la Dettatura Intelligente per leggere un post in modo naturale, poi riscrivilo per adattarne il tono: funziona allo stesso modo su LinkedIn, Slack, Discord e altre piattaforme.",
        "complete": {
            "description": "Ora sai come dettare un post e perfezionarlo con Rewrite, su LinkedIn, Slack, Discord e altro ancora."
        }
    },
    "aiDocumentTranslation": {
        "tourLabel": "Traduci documenti in qualsiasi lingua, direttamente sul dispositivo.",
        "learn": "Cephable è in grado di tradurre un documento in una lingua alla volta, oppure di utilizzare flussi di lavoro basati sull'intelligenza artificiale per tradurlo contemporaneamente in più lingue, il tutto in locale.",
        "complete": {
            "description": "Ora sai come tradurre un documento in una singola lingua tramite dettatura, oppure in più lingue contemporaneamente con i flussi di lavoro basati sull'intelligenza artificiale, il tutto direttamente sul dispositivo."
        }
    },
    "excelAiAutomation": {
        "tourLabel": "Analizza i fogli di calcolo con l'intelligenza artificiale privata integrata nel dispositivo.",
        "learn": "Cephable è in grado di analizzare i tuoi file Excel, rispondere a domande sui dati numerici e approfondire ulteriormente l'analisi, il tutto senza che i tuoi dati lascino il tuo dispositivo.",
        "complete": {
            "description": "Ora sai come utilizzare i flussi di lavoro basati sull'IA per analizzare i tuoi fogli di calcolo, approfondire le analisi con domande di follow-up e salvare un riepilogo, il tutto direttamente sul tuo dispositivo."
        }
    },
    "handsFreeComputerControl": {
        "tourLabel": "Controlla il tuo computer con la voce e la videocamera.",
        "learn": "Cephable ti permette di controllare il computer a mani libere utilizzando comandi vocali, Voice Mouse e controlli basati su movimenti della testa e del viso tramite fotocamera.",
        "tryOpenWord": {
            "title": "Prova a dire \"Apri parola\""
        },
        "openExtensions": {
            "title": "Apri la scheda Estensioni",
            "description": "Per attivare i controlli della fotocamera, apri la scheda Estensioni nella finestra principale."
        },
        "turnOnCamera": {
            "title": "Attiva i controlli della fotocamera",
            "description": "Attiva la fotocamera. Accanto all'icona del microfono comparirà un'icona a forma di fotocamera e nelle Impostazioni verrà visualizzata una nuova sezione \"Fotocamera\"."
        },
        "cameraInPanel": {
            "title": "Comandi della fotocamera nel pannello",
            "description": "Ora che i controlli della fotocamera sono attivi, l'interruttore della fotocamera appare anche nel pannello di Cephable: Cephable lo attiva automaticamente da qui."
        },
        "openCameraSettings": {
            "title": "Apri le impostazioni della fotocamera",
            "description": "Apri le impostazioni della fotocamera per personalizzare il funzionamento dei controlli per la testa e il viso."
        },
        "chooseHeadMouseMode": {
            "title": "Scegli una modalità mouse-testa",
            "description": "Scegli come il movimento della testa controlla il mouse: Steady Glide, Speed Boost o Dynamic Glide."
        },
        "complete": {
            "description": "Ora sai come controllare il computer con la voce, il mouse vocale e i comandi basati su movimenti della testa e del viso tramite la fotocamera. Esplora ulteriormente le impostazioni della fotocamera per configurare i controlli più adatti alle tue esigenze."
        }
    },
    "handsFreeTypingDocumentCreation": {
        "tourLabel": "Crea e modifica documenti senza usare le mani",
        "learn": "Utilizza le funzioni Genera, Riscrivi e i comandi vocali insieme per creare e modificare un documento, come una fattura, quasi completamente senza usare le mani.",
        "complete": {
            "description": "Ora sai come generare, riscrivere e modificare un documento quasi completamente a mani libere utilizzando i comandi Genera, Riscrivi e i comandi vocali."
        }
    },
    "webResearchCreateHtml": {
        "tourLabel": "Ricerca sul Web e crea un sito web a partire dai risultati ottenuti, tutto direttamente sul dispositivo.",
        "learn": "Cephable è in grado di esplorare e analizzare i siti web dei concorrenti, quindi utilizzare le informazioni raccolte per generare un nuovo sito HTML per te, il tutto direttamente sul dispositivo, garantendo così la privacy delle tue ricerche.",
        "complete": {
            "description": "Ora sai come utilizzare i flussi di lavoro basati sull'intelligenza artificiale per analizzare i siti web dei concorrenti e generare un nuovo sito HTML a partire dai risultati ottenuti, il tutto senza che i tuoi dati lascino il tuo dispositivo."
        }
    },
    "webResearchSummarize": {
        "tourLabel": "Regolamentazione della ricerca e riepilogo dei risultati — Tutto sul dispositivo",
        "learn": "Cephable può navigare sul web per ricercare modifiche come le nuove leggi sulla protezione dei dati, quindi riassumere i risultati in un documento su cui il tuo team può intervenire, il tutto direttamente sul dispositivo, garantendo così la privacy delle tue ricerche.",
        "complete": {
            "description": "Ora sai come utilizzare i flussi di lavoro basati sull'IA per ricercare modifiche normative, approfondire l'implementazione e redigere i risultati in un'e-mail che il tuo team potrà modificare, il tutto senza che i tuoi dati lascino il tuo dispositivo."
        }
    },
    "stopListening": {
        "title": "Prova a dire \"Smetti di ascoltare\".",
        "description": "In questo modo il microfono si mette in pausa senza essere disattivato completamente. Pronuncia di nuovo \"Inizia ad ascoltare\" quando sei pronto."
    }
}
